<template>
    <div class="message">
        <ul>
            <li>{{msg.title}}</li>
            <li>老师：{{msg.speaker}}</li>
            <li>时长：{{msg.resTime}}</li>
            <li>
                <span>
                    <i class="eye"></i>
                    {{msg.clickTimes}}
                </span>
                <span>
                    <i class="star"></i>
                    {{msg.collectTimes}}
                </span>
                <span>
                    <i class="like"></i>
                    {{msg.likeTimes}}
                </span>
            </li>
        </ul>    
    </div>
</template>

<script>

export default{
    name: 'Message',
    props:{
        msg: Object    
    }
}
</script>

<style lang="less" scoped>
    .message{
        padding: 0 0.3rem 0.45rem 0.3rem;
        li{
            margin-bottom: 0.16rem;
            font-size: 0.46rem;
            color: #000;
            &:nth-of-type(2){
                font-size: 0.38rem;
                color: #4b4a4a;
            }
            &:nth-of-type(3){
                font-size: 0.35rem;
                color: #7b7a7a;
            }
            span{
                margin-right: 0.2rem;
                font-size: 0.3rem;
                color: #7b7a7a;
            }
            i{
                display: inline-block;
                vertical-align: middle;
            }
            .eye{
                width: 0.45rem;
                height: 0.32rem;
                background: url("../../assets/images/eye_icon.png") no-repeat;
                background-size: 100%;    
            }
            .star{
                width: 0.4rem;
                height: 0.45rem;
                background: url("../../assets/images/star_icon.png") no-repeat;
                background-size: 100%;    
            }
            .like{
                width: 0.4rem;
                height: 0.42rem;
                background: url("../../assets/images/like_icon.png") no-repeat;
                background-size: 100%;    
            }
        }
    }            
</style>   